export const NAV_LINKS = [
    { label: "Home", id: "home" },
    { label: "About Us", id: "about" },
    { label: "Our Companies", id: "companies" },
    { label: "Platforms", id: "platforms" },
    { label: "Strategic Roadmap", id: "roadmap" },
    { label: "Projects / Capabilities", id: "projects" },
    { label: "Investor Relations", id: "investors" },
    { label: "Contact", id: "contact" },
];

const img = (id, w = 1920) =>
    `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
    hero: img("photo-1769020914656-f7ac8a61cbf4", 2400),
    digon: img("photo-1509391111737-9b07f052f6b6"),
    sadjaGroup: img("photo-1644221150186-5d785a471f44"),
    orbito: img("photo-1509390673020-a5b2450e33f1"),
    about: img("photo-1510507024924-fc3847d49ae2"),
    investors: img("photo-1758518729685-f88df7890776"),
    gridTexture: img("photo-1524351543168-8e38787614e9"),
};

export const LOGO = "/assets/sadja-core-logo.jpg";

export const CONTACT = {
    email: "official@sadjacorecorp.com",
    address: [
        "Jl. Jenderal Sudirman No.Kav. 86,",
        "RT.10/RW.11, Karet Tengsin,",
        "Kecamatan Tanah Abang,",
        "Kota Jakarta Pusat,",
        "Daerah Khusus Ibukota Jakarta 10220,",
        "Indonesia",
    ],
    whatsapp: "https://api.whatsapp.com/send?phone=62817581774&text=%20Halo",
    whatsappLabel: "+62 817-581-774",
};

export const SECTORS = [
    {
        num: "01",
        title: "ENERGY",
        desc: "Power generation, renewable energy, hybrid systems and strategic energy assets.",
        icon: "Zap",
    },
    {
        num: "02",
        title: "TRANSMISSION",
        desc: "High-voltage transmission, substations, grid expansion and commissioning.",
        icon: "Cable",
    },
    {
        num: "03",
        title: "INFRASTRUCTURE",
        desc: "Construction, property development and strategic infrastructure.",
        icon: "Building2",
    },
];

export const WHY_SADJA = [
    {
        num: "01",
        title: "HIGH-GROWTH MARKET",
        desc: "Operating within one of the fastest-growing infrastructure regions.",
        icon: "TrendingUp",
    },
    {
        num: "02",
        title: "EXPERIENCED INDUSTRY NETWORK",
        desc: "Built upon decades of collective industry experience in transmission and energy projects.",
        icon: "Network",
    },
    {
        num: "03",
        title: "LONG-TERM VISION",
        desc: "Focused on creating sustainable enterprise value rather than short-term project gains.",
        icon: "Landmark",
    },
    {
        num: "04",
        title: "STRATEGIC FOCUS",
        desc: "Focused on high-barrier energy and infrastructure sectors.",
        icon: "Crosshair",
    },
    {
        num: "05",
        title: "SCALABLE BUSINESS MODEL",
        desc: "Evolution from contractor to EPC platform to infrastructure asset owner.",
        icon: "Layers",
    },
];

export const ROADMAP = [
    {
        year: "2026",
        title: "FOUNDATIONS",
        note: "Establish operational credibility and secure flagship projects.",
        bullets: [
            "Establish operational credibility",
            "Execute first major transmission and substation projects",
            "Build EPC support capability",
            "Establish PLTMG platform capability",
            "Establish commissioning and O&M platform",
            "Corporate governance implementation",
            "Investor readiness framework",
        ],
    },
    {
        year: "2027",
        title: "EXPANSION",
        note: "Scale project execution capacity.",
        bullets: [
            "Multiple GI projects",
            "Data center infrastructure",
            "SUTT/SUTET packages",
            "PLTMG EPC participation",
            "Solar EPC projects",
            "Industrial power systems",
            "Regional partnerships",
        ],
    },
    {
        year: "2028",
        title: "SCALING",
        note: "Transition from contractor toward infrastructure platform.",
        bullets: [
            "Begin minority ownership in energy assets",
            "Establish SPV structures",
            "Develop recurring revenue streams",
            "Transition from contractor toward infrastructure platform",
        ],
    },
    {
        year: "2029",
        title: "REGIONAL PLATFORM",
        note: "Expand beyond Indonesia.",
        markets: ["Malaysia", "Philippines", "Vietnam"],
        bullets: [
            "Regional EPC partnerships",
            "Asset acquisition",
            "Infrastructure investment",
        ],
    },
    {
        year: "2030",
        title: "INFRASTRUCTURE GROUP",
        note: "Become a leading integrated infrastructure platform.",
        bullets: ["Become a leading integrated infrastructure platform."],
    },
];

export const ASSET_STAGES = [
    {
        num: "1",
        period: "2026–2027",
        title: "ASSET LIGHT MODEL",
        groups: [
            {
                label: "Focus",
                items: ["EPC", "Commissioning", "O&M Services"],
            },
        ],
        highlight: "Strategic Focus: Execution & Cash",
    },
    {
        num: "2",
        period: "2028–2030",
        title: "HYBRID ASSET MODEL",
        groups: [
            {
                label: "Energy Assets",
                items: ["Solar Farms", "Captive Plants", "Hybrid Systems"],
            },
            {
                label: "Utility Assets",
                items: ["Energy Infrastructure", "Industrial Utilities"],
            },
        ],
        highlight: "Target Asset Base: Rp 1–2 Trillion",
    },
    {
        num: "3",
        period: "2031–2035",
        title: "ASSET OWNERSHIP PLATFORM",
        groups: [
            {
                label: "IPP Target",
                items: ["PLTMG", "Solar", "Hybrid Power Plants"],
            },
            {
                label: "Utility Infra",
                items: ["Industrial Energy Systems", "Data Center Power"],
            },
        ],
        highlight: "Target Asset Value: Rp 10–20 Trillion",
    },
];

export const LEADERSHIP = [
    {
        name: "Bito Leilia Atmadja",
        role: "Founder & President Director",
        areas: [
            "Corporate Strategy",
            "Investment Direction",
            "Business Development",
            "Strategic Partnerships",
        ],
        vision: "“Building a world-class infrastructure and energy platform originating from Southeast Asia.”",
    },
    {
        name: "Bima Eka Sakti",
        role: "President Commissioner",
        areas: [
            "Corporate Governance",
            "Government Relations",
            "Strategic Oversight",
        ],
    },
    {
        name: "To Be Appointed",
        role: "Finance Director",
        areas: [
            "Capital Management",
            "Financial Planning",
            "Investor Relations",
            "Fundraising",
        ],
        vacant: true,
    },
];

export const INVESTOR_CARDS = [
    {
        num: "01",
        title: "STRATEGIC PARTNERS",
        desc: "Infrastructure and energy partnerships",
        icon: "Handshake",
    },
    {
        num: "02",
        title: "CAPITAL PARTNERS",
        desc: "Long-term infrastructure investment",
        icon: "LineChart",
    },
    {
        num: "03",
        title: "PROJECT PARTNERS",
        desc: "EPC, utilities, developers and strategic stakeholders",
        icon: "Users",
    },
];
